export class RequestXplorerCardRegistration {
        fullName: string;
        mobile: string;
        email: string;
        consumerId: string;
        profession: string;
        companyName: string;
        designation: string;
        platform: string;
        userName: string;
        preferredName: string;
        referralCode: string;
}
